// import Vue from 'vue';
import {
    BAROMETER_SUBMIT,
    NAVIGATION_OPEN,
    SAVE_TOKEN,
    SEND_TOKEN,
    STORE_NAVIGATION,
    STORE_NEWS,
    STORE_NEWS_CATEGORIES,
    STORE_EVENTS,
    NEWS_SET_LIKES,
    STORE_IMPRESSIONS,
    ARTICLE_UPDATE,
    STORE_BULLETIN,
    ADD_ARTICLE,
    STORE_BULLETIN_CATEGORIES
} from '../actions/general';
import {AUTH_LOGOUT} from '../actions/auth';

const state = {
	navigation : 'is-opening',
	navigationItems : [],
	barometerSubmitted : false,
	tokenSent : false,
	pushToken : null,
    newsItems: [],
    newsCategories: [],
    calendarEvents : [],
    impressionItems: [],
    bulletinItems: [],
    bulletinCategories: []
};

const getters = {
	navigationState : (state) => state.navigation,
	barometerSubmitted : (state) => state.barometerSubmitted,
	isTokenSent : (state) => state.tokenSent,
	getToken : (state) => state.pushToken,
    getNavigationItems: (state) => state.navigationItems,
    navigationHasItem: (state) => (item) => {
	    let found = state.navigationItems.filter( ni => ni.title === item);
	    return found.length > 0;
    },
    newsItems: (state) => state.newsItems,
    newsCategories: (state) => state.newsCategories,
    calendarEvents: (state) => state.calendarEvents,
    impressionItems: (state) => state.impressionItems,
    bulletinItems: (state) => state.bulletinItems,
    bulletinCategories: (state) => state.bulletinCategories
};

const actions = {
	[AUTH_LOGOUT] : ({commit,dispatch}) => {
		commit( NAVIGATION_OPEN, 'is-closing' );
	}
};

const mutations = {
	[NAVIGATION_OPEN] : (state, navStatus) => {
		state.navigation = navStatus;
	},
	[BAROMETER_SUBMIT] : (state, submit ) => {
		state.barometerSubmitted = submit;
	},
	[SEND_TOKEN] : (state, sent ) => {
		state.tokenSent = sent;
	},
	[SAVE_TOKEN] : (state, token ) => {
		state.pushToken = token;
	},
	[STORE_NAVIGATION] : (state, navigation ) => {
		state.navigationItems = navigation;
	},
    [STORE_NEWS] : (state, news ) => {
        state.newsItems = news;
    },
    [STORE_NEWS_CATEGORIES] : (state, categories ) => {
        state.newsCategories = categories;
    },
    [STORE_EVENTS] : (state, events ) => {
	    state.calendarEvents = events;
    },
    [NEWS_SET_LIKES] : (state, data ) => {
	    let list = [], idx;
	    if( data.target === 'news' ) {
            list = state.newsItems;
        }
	    else if ( data.target === 'impression' ) {
	        list = state.impressionItems;
        }
	    idx = list.indexOf( data.article );
        if( idx !== -1 ) {
            list[ idx ].likes = data.likes;
        }
    },

    [STORE_IMPRESSIONS]: (state, data) => {
	    state.impressionItems = data;
    },

    [STORE_BULLETIN]: (state, data) => {
        state.bulletinItems = data;
    },
    [ADD_ARTICLE]: ( state, data ) => {
        switch( data.target ) {
            case 'news' : state.newsItems.unshift( data.newArticle ); break;
            case 'impression' : state.impressionItems.unshift( data.newArticle ); break;
            case 'bulletin' : state.bulletinItems.unshift( data.newArticle ); break;
        }

    },
    [STORE_BULLETIN_CATEGORIES]: (state, data) => {
        state.bulletinCategories = data;
    },

    [ARTICLE_UPDATE]: (state, data ) => {
        let list = [], idx;

        switch( data.target ) {
            case 'news' : list = state.newsItems; break;
            case 'impression' : list = state.impressionItems; break;
            case 'bulletin' : list = state.bulletinItems; break;
        }

        idx = list.findIndex((item)=> item.uid === data.article.uid );
        if( idx !== -1 ){
            list[idx] = Object.assign(list[idx], data.newData );
        }
    }

};

export default {
	state,
	getters,
	actions,
	mutations
};



// WEBPACK FOOTER //
// ./src/utils/store/modules/general.js